import { render } from "./alloverTaxReportOwners.vue?vue&type=template&id=5df58ee6&scoped=true"
import script from "./alloverTaxReportOwners.vue?vue&type=script&lang=js"
export * from "./alloverTaxReportOwners.vue?vue&type=script&lang=js"

import "./alloverTaxReportOwners.vue?vue&type=style&index=0&id=5df58ee6&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df58ee6"]])

export default __exports__